<section class="webinar-banner">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <h1>Trinka Webinars</h1>
                <p>Discover new trends, learn from industry experts, and uncover the advancements and impact of AI in academics</p>
            </div>
            <div class="col-lg-5 col-md-6 offset-lg-1">
                <img src="/assets/images/webinar/banner-illustration.svg" class="img-fluid" alt="trinka webinars" />
            </div>
        </div>
    </div>
</section>

<section class="webinar-tabs">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <ul>
                    <!-- <li (click)="scrollToElementWithOffset('upcomingEvent', 120)">Upcoming Event</li> -->
                    <li (click)="scrollToElementWithOffset('pastEvent', 120)">Past Event</li>
                    <li (click)="scrollToElementWithOffset('institutionalWebinar', 120)">Institutional Webinar</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="section-pd upcomingEvent d-none" id="upcomingEvent">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="trinka-title mb-0 text-center">
                <h2>Upcoming Events</h2>
                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="upcomingEvent-right">
                    <h4>From Idea to Impact: High-Quality Content Creation Made Easy with Specialized AI Apps</h4>
                    <ul>
                        <li>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.2917 3.22729L13.1214 3.22731V2.18929C13.1214 1.90153 12.8884 1.66846 12.6006 1.66846C12.3128 1.66846 12.0798 1.90153 12.0798 2.18929V3.22705H7.9131V2.18929C7.9131 1.90153 7.68003 1.66846 7.39227 1.66846C7.10451 1.66846 6.87144 1.90153 6.87144 2.18929V3.22705H2.70841C2.13315 3.22705 1.66675 3.69346 1.66675 4.26872V17.2896C1.66675 17.8648 2.13315 18.3312 2.70841 18.3312H17.2917C17.867 18.3312 18.3334 17.8648 18.3334 17.2896V4.26872C18.3334 3.6937 17.867 3.22729 17.2917 3.22729ZM17.2917 17.2896H2.70841V4.26872H6.87144V4.79346C6.87144 5.0812 7.10451 5.31429 7.39227 5.31429C7.68003 5.31429 7.9131 5.0812 7.9131 4.79346V4.26898H12.0798V4.79372C12.0798 5.08148 12.3128 5.31455 12.6006 5.31455C12.8884 5.31455 13.1214 5.08148 13.1214 4.79372V4.26898H17.2917V17.2896ZM13.6459 9.99813H14.6876C14.9751 9.99813 15.2084 9.76479 15.2084 9.47729V8.43563C15.2084 8.14813 14.9751 7.91479 14.6876 7.91479H13.6459C13.3584 7.91479 13.1251 8.14813 13.1251 8.43563V9.47729C13.1251 9.76479 13.3584 9.99813 13.6459 9.99813ZM13.6459 14.1645H14.6876C14.9751 14.1645 15.2084 13.9315 15.2084 13.6437V12.602C15.2084 12.3145 14.9751 12.0812 14.6876 12.0812H13.6459C13.3584 12.0812 13.1251 12.3145 13.1251 12.602V13.6437C13.1251 13.9317 13.3584 14.1645 13.6459 14.1645ZM10.5209 12.0812H9.47925C9.19175 12.0812 8.95841 12.3145 8.95841 12.602V13.6437C8.95841 13.9315 9.19175 14.1645 9.47925 14.1645H10.5209C10.8084 14.1645 11.0417 13.9315 11.0417 13.6437V12.602C11.0417 12.3148 10.8084 12.0812 10.5209 12.0812ZM10.5209 7.91479H9.47925C9.19175 7.91479 8.95841 8.14813 8.95841 8.43563V9.47729C8.95841 9.76479 9.19175 9.99813 9.47925 9.99813H10.5209C10.8084 9.99813 11.0417 9.76479 11.0417 9.47729V8.43563C11.0417 8.14787 10.8084 7.91479 10.5209 7.91479ZM6.35425 7.91479H5.31258C5.02508 7.91479 4.79175 8.14813 4.79175 8.43563V9.47729C4.79175 9.76479 5.02508 9.99813 5.31258 9.99813H6.35425C6.64175 9.99813 6.87508 9.76479 6.87508 9.47729V8.43563C6.87508 8.14787 6.64175 7.91479 6.35425 7.91479ZM6.35425 12.0812H5.31258C5.02508 12.0812 4.79175 12.3145 4.79175 12.602V13.6437C4.79175 13.9315 5.02508 14.1645 5.31258 14.1645H6.35425C6.64175 14.1645 6.87508 13.9315 6.87508 13.6437V12.602C6.87508 12.3148 6.64175 12.0812 6.35425 12.0812Z" fill="black"/>
                            </svg>
                            March 05, 20245
                        </li>
                        <li>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 2.5C5.85938 2.5 2.5 5.85938 2.5 10C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 10C17.5 5.85938 14.1406 2.5 10 2.5Z" stroke="black" stroke-width="0.923077" stroke-miterlimit="10"/>
                                <path d="M10 5V10.625H13.75" stroke="black" stroke-width="0.923077" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            8:00 AM ET
                        </li>
                    </ul>
                    <div class="btn-group">
                        <!-- <a [routerLink]="['/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports']" fragment="registerForm" class="filled-btn">Register Now</a> -->
                        <a [routerLink]="['/webinars/from-idea-to-impact-high-quality-content-creation-made-easy-with-specialized-ai-apps']" class="outline-btn">Know More</a>
                        <!-- <span>Its Free!
                            <svg width="84" height="13" viewBox="0 0 84 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.22647 10.1379C19.9095 6.04479 64.059 -0.242496 81.7265 3.63794" stroke="#FFD900" stroke-width="4" stroke-linecap="round"/>
                            </svg>
                        </span> -->
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="upcomingEvent-img">
                    <img src="/assets/images/webinar/webinar.jpg" class="img-fluid" loading="lazy" alt="trinka webinars" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd section-purple" id="pastEvent">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="trinka-title mb-30 text-center">
                <h2>Past Events</h2>
                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="owl-carousel owl-theme" id="podcastSlider">
                    <div class="item">
                        <div class="pastEvent">
                            <div class="webinar-img">
                                <!-- <img src="/assets/images/webinar/webinar-3.png" class="img-fluid" loading="lazy" alt="trinka webinars" /> -->
                                <button type="button" data-toggle="modal" data-target="#webinarVideo4">
                                    <img src="/assets/images/webinar/webinar-3.png" class="img-fluid" loading="lazy" alt="trinka webinars" />
                                    <span></span>
                                </button>
                            </div>
                            <div class="webinar-content">
                                <!-- <span>Ethical AI</span> -->
                                <a [routerLink]="['/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports']">Improving Research Manuscripts Using AI-Powered Insights</a>
                                <div class="btn-group">
                                    <a [routerLink]="['/webinars/improving-research-manuscripts-using-ai-powered-insights-enago-reports']" class="filled-btn">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="pastEvent">
                            <div class="webinar-img">
                                <button type="button" data-toggle="modal" data-target="#webinarVideo3">
                                    <img src="/assets/images/webinar/webinar-3.png" class="img-fluid" loading="lazy" alt="trinka webinars" />
                                    <span></span>
                                </button>
                            </div>
                            <div class="webinar-content">
                                <!-- <span>Ethical AI</span> -->
                                <a [routerLink]="['/webinars/using-ai-for-plagiarism-prevention-and-ai-content-detection']">Using AI for Plagiarism Prevention and AI-Content Detection in Academic Writing</a>
                                <div class="btn-group">
                                    <a [routerLink]="['/webinars/using-ai-for-plagiarism-prevention-and-ai-content-detection']" class="filled-btn">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="pastEvent">
                            <div class="webinar-img">
                                <button type="button" data-toggle="modal" data-target="#webinarVideo2">
                                    <img src="/assets/images/webinar/webinar-2.png" class="img-fluid" loading="lazy" alt="trinka webinars" />
                                    <span></span>
                                </button>
                            </div>
                            <div class="webinar-content">
                                <!-- <span>Ethical AI</span> -->
                                <a [routerLink]="['/webinars/ai-for-accuracy-in-research-and-academic-writing']">AI for Accuracy in Research and Academic Writing</a>
                                <div class="btn-group">
                                    <a [routerLink]="['/webinars/ai-for-accuracy-in-research-and-academic-writing']" class="filled-btn">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="pastEvent">
                            <div class="webinar-img">
                                <button type="button" data-toggle="modal" data-target="#webinarVideo1">
                                    <img src="/assets/images/webinar/webinar-1.png" class="img-fluid" loading="lazy" alt="trinka webinars" />
                                    <span></span>
                                </button>
                            </div>
                            <div class="webinar-content">
                                <!-- <span>Ethical AI</span> -->
                                <a [routerLink]="['/webinars/how-to-use-ai-to-improve-your-academic-writing']">How to Use AI to Improve Your Academic Writing</a>
                                <div class="btn-group">
                                    <a [routerLink]="['/webinars/how-to-use-ai-to-improve-your-academic-writing']" class="filled-btn">Know More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>

<app-global-leaders></app-global-leaders>

<section class="section-pd" id="institutionalWebinar">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="trinka-title mb-0 text-center">
                <h2>Institutional Webinar</h2>
                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-6 col-lg-6">
                <h4 class="mb-30">Explore the Future of AI with Us</h4>
                <p>The field of Artificial Intelligence is exploding with advancements that will shape our future. Don't miss out! Collaborate with us in these groundbreaking webinars where we dissect the latest breakthroughs and their real-world applications</p>
            </div>
            <div class="col-lg-5 offset-lg-1 col-md-6">
                <img src="/assets/images/word-add-in-banner.svg" class="img-fluid" alt="explore future AI" />
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="partnerUS">
                    <div class="row">
                        <div class="col-lg-7 col-md-8">
                            <div class="trinka-title mb-0">
                                <h2 class="mb-3">​​Partner with us! </h2>
                                <p class="mb-30">Co-host a FREE AI webinar at your university.</p>
                                <div class="btn-group">
                                    <button type="button" class="filled-btn" (click)="scrollToElementWithOffset('getInTouch', 100)">Get in Touch</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-4">
                            <img src="/assets/images/webinar/university.png" class="d-none d-md-block" loading="lazy" alt="university" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="cloud_key_features section-pd list-wrapper-style-2 section-purple ">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Collaborate with us?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 offset-lg-2">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="review changes">
                    <h3>Knowledge Sharing </h3>
                    <p>Opportunity to share research findings and innovative solutions in AI with a broader audience.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-1">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/RetainOriginalFormatting.png" alt="retian original formatting">
                    <h3>Student Engagement </h3>
                    <p>Providing students with the opportunity to learn from and engage with experts outside their university.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-2">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/languageScore_icon.svg" alt="language score">
                    <h3>Visibility </h3>
                    <p>Enhancing the university's visibility as a thought leader in AI research and education.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-lg-1">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/TableofRevisions_icon.svg" alt="table of revisions">
                    <h3>Networking </h3>
                    <p>Connecting with other leading academics, professionals, and enthusiasts in the field of AI.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-pd webinar-contact-form" id="getInTouch">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-9">
                <div class="contact_forms">
                    <form [formGroup]="contactForm" (ngSubmit)="processForm()">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group"
                                    [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Your name *</mat-label>
                                        <input id="contactUserName" matInput placeholder="" formControlName="contactFormName"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group"
                                    [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Email *</mat-label>
                                        <input id="contactUserEmail" matInput placeholder="" formControlName="contactFormEmail"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group"
                                    [ngClass]="(!contactForm.get('contactFormDestination').valid && contactForm.get('contactFormDestination').dirty) || (contactForm.get('contactFormDestination').touched && contactForm.get('contactFormDestination').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Designation *</mat-label>
                                        <input id="contactUserSubject" matInput placeholder="" formControlName="contactFormDestination"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group"
                                    [ngClass]="(!contactForm.get('contactFormInstitution').valid && contactForm.get('contactFormInstitution').dirty) || (contactForm.get('contactFormInstitution').touched && contactForm.get('contactFormInstitution').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Institution *</mat-label>
                                        <input id="contactUserSubject" matInput placeholder="" formControlName="contactFormInstitution"
                                            class="form-control">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group select-group" [ngClass]="(contactForm.get('contactFormTopList').value === '' && contactForm.get('contactFormTopList').touched) ? 'TextFiledError' : ''">
                                    <mat-form-field>
                                        <mat-label>Top List</mat-label>
                                        <select matNativeControl required formControlName="contactFormTopList">
                                            <option value="" selected></option>
                                            <option value="Enhancing Academic Writing with AI">Enhancing Academic Writing with AI</option>
                                            <option value="AI-Powered Literature Review: Streamlining the Research Process">AI-Powered Literature Review: Streamlining the Research Process</option>
                                            <option value="AI in Academic Publishing: Trends, Opportunities, and Challenges">AI in Academic Publishing: Trends, Opportunities, and Challenges</option>
                                            <option value="Ethical Considerations in AI-Assisted Academic Writing and Publication">Ethical Considerations in AI-Assisted Academic Writing and Publication</option>
                                            <option value="Responsible Use of AI Tools: Policies and Practices">Responsible Use of AI Tools: Policies and Practices</option>
                                        </select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="col-sm-12">
                                <div class="form-group textareaBox"
                                    [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Your Message *</mat-label>
                                        <textarea id="contactUserMessage" matInput formControlName="contactFormMessage" placeholder=""
                                            class="form-control"></textarea>
                                    </mat-form-field>
                                </div>
                            </div> -->

                            <div class="col-sm-12">
                                <div class="form-group btn-group justify-content-center">
                                    <button type="submit" class="filled-btn" id="contactUserSendMessage">Get in Touch</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="academicInstitutions">
                    <span class="line-graphics">
                        <img src="/assets/images/webinar/lines.png" loading="lazy" class="img-fluid" alt="icons" />
                    </span>
                    <div class="row">
                        <div class="col-md-8">
                            <div class="trinka-title mb-0">
                                <h3 class="mb-3 text-white">Trinka for Academic Institutions</h3>
                                <p class="mb-30 text-white">Accelerate publication success with advanced academic writing assistance.</p>
                                <div class="btn-group">
                                    <a [routerLink]="['/enterprise/academic-institutions']" class="white-btn">Know More</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                             <img src="/assets/images/webinar/academic.png" loading="lazy" class="img-fluid" alt="Academic Institutions" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="modal fade" id="webinarVideo1" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" width="100%" height="642" src="https://www.youtube.com/embed/N3h20DcqLck"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="webinarVideo2" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" width="100%" height="642" src="https://www.youtube.com/embed/cgB1J2FYP-0"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="webinarVideo3" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" width="100%" height="642" src="https://www.youtube.com/embed/z8LVBSL1SMg"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="webinarVideo4" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" width="100%" height="642" src="https://www.youtube.com/embed/7qxDl7LGBfI?si=_OE-LHeG-5YLzixW"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>